import { useState, useCallback } from "react";

import { strCode } from "../../consts";
import { deviceCertificatesService, notificationService, t } from "../../services";
import { parseErrorMessage } from "./useCreateCertificates";

export const useFetchCertificateInfo = () => {
  const [certificatesInfo, setCertificatesInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchCallback = useCallback(async (dusn) => {
    if (certificatesInfo || loading) {
      return;
    }

    setError(null);
    setLoading(true);
    setCertificatesInfo(null);

    try {
      const certificates = await deviceCertificatesService.getDeviceCertificates(dusn);
      setCertificatesInfo(certificates);

      return certificates;
    } catch (err) {
      setError(null);

      notificationService.showError({
        title: t(strCode.FETCH_DEVICE_CERTIFICATE_ERROR),
        message: t(parseErrorMessage(err))
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return { fetchCallback, data: certificatesInfo, loading, error };
};
